class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.back-to-top-button');
    this.scrollThreshold = parseInt(this.dataset.scrollThreshold) || 50;
    this._handleScroll = this._handleScroll.bind(this);
    this._handleClick = this._handleClick.bind(this);
  }

  connectedCallback() {
    // 绑定滚动事件
    window.addEventListener('scroll', this._handleScroll, { passive: true });
    // 绑定点击事件
    this.button.addEventListener('click', this._handleClick);
    // 初始化状态
    this._handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._handleScroll);
    this.button.removeEventListener('click', this._handleClick);
  }

  _handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > this.scrollThreshold) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  _handleClick(event) {
    event.preventDefault();
    // 平滑滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('back-to-top', BackToTop);